import React from 'react';

import { DescriptionList, DescriptionItem } from '@gogame/components';

import { getPeriodValue } from 'scenes/Events/utils';

const GeneralSection = ({ data }) => {
  return (
    <DescriptionList disableGutters data={data}>
      <DescriptionItem
        label={'Application'}
        field={'application.name'}
        type={'text'}
        placeholder={'—'}
      />
      <DescriptionItem
        placeholder={'—'}
        label={'Event'}
        field={'eventTrigger'}
        type={'text'}
      />
      <DescriptionItem
        placeholder={'—'}
        label={'Period'}
        field={'period'}
        value={getPeriodValue(data.period)}
        type={'text'}
      />
      <DescriptionItem
        placeholder={'—'}
        label={'Purchase data'}
        field={'purchaseData'}
        type={'text'}
      />
      <DescriptionItem
        placeholder={'—'}
        label={'GG event name'}
        field={'ggEventName'}
        type={'text'}
      />
      <DescriptionItem
        placeholder={'—'}
        label={'Description'}
        field={'description'}
        type={'text'}
      />
    </DescriptionList>
  );
};

export default GeneralSection;
